export enum ATTRIBUTES {
    Description = "description",
    GsmNumber = "gsm_number",
    ICCID = "iccid",
    IMSI = "imsi"
}
